import React from 'react';
import { Spinner, type SpinnerProps } from '@/components/ui/spinner';

interface LoadingSpinnerProps extends Omit<SpinnerProps, 'size'> {
  label?: string;
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ label, className, ...props }) => {
  // Map the old className based sizing to the new size prop
  // Default to 'xl' to maintain backward compatibility with h-12 w-12
  let size: SpinnerProps['size'] = 'xl';
  
  if (className?.includes('h-4') || className?.includes('w-4')) {
    size = 'sm';
  } else if (className?.includes('h-6') || className?.includes('w-6')) {
    size = 'md';
  } else if (className?.includes('h-8') || className?.includes('w-8')) {
    size = 'lg';
  }
  
  return <Spinner size={size} label={label} className={className} {...props} />;
};